import { AfterContentInit, Component, ElementRef, Input, OnDestroy, OnInit, inject, input, output, viewChild } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { tap } from 'rxjs/operators';
import { untilDestroyed } from 'ngx-unificator/rxjs';
import { UntilDestroy } from 'ngx-unificator/decorator';
import { merge } from 'rxjs';
import { FormsErrorHandlerService } from '../../../services/forms-error-handler.service';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '../../translation/translate.pipe';
import { PlatformService } from 'ngx-unificator/services';

@UntilDestroy()
@Component({
    selector: 'app-form-input',
    templateUrl: './form-input.component.html',
    styleUrls: ['./form-input.component.scss'],
    imports: [NgClass, TranslatePipe]
})
export class FormInputComponent implements OnInit, AfterContentInit, OnDestroy {
  private _formErrors = inject(FormsErrorHandlerService);
  private _el = inject(ElementRef);
  private _platform = inject(PlatformService);


  /**
   * List of messages for current control
   */
  public messages: Array<string> = [];

  public placeholder: any = null;

  /**
   * Text label over input
   */
  @Input() label;

  @Input() additionalLabel: string;

  /**
   * List of errors for current control
   */
  @Input() errors: Array<any> = [];

  /**
   * List of validationMessages for current control
   */
  @Input() validationMessages: Array<string> = [];

  /**
   * Form control
   */
  @Input() control: AbstractControl;

  /**
   * Bottom placeholder
   */
  @Input() bottomPlaceholder: string;

  readonly class = input<string>(undefined);

  /**
   * Is top label default
   */
  readonly isTopLabelDefault = input<boolean>(undefined);

  /**
   * Emit if update errors
   */
  readonly updateErrors$ = output<any[]>();

  readonly input = viewChild<ElementRef>('input');

  ngOnInit() {
    if (this.control) {
      this.errors = this._formErrors.errors(this.control);
      this._updateErrorsAndMessages(this.errors);

      merge(this.control.statusChanges, this.control.valueChanges)
        .pipe(
          untilDestroyed(this),
          tap(() => {
            const errors = this._formErrors.errors(this.control);
            this.updateErrors$.emit(errors);
            this._updateErrorsAndMessages(errors);
          }),
        )
        .subscribe();
    }
  }

  ngAfterContentInit() {
    if (this._el.nativeElement?.querySelector('input') && this._platform.isBrowser) {
      this.placeholder = this._el.nativeElement?.querySelector('input').placeholder;
    }
  }

  ngOnDestroy(): void {}

  /**
   * Update errors and messages array for view
   *
   * @param errors
   * @private
   */
  private _updateErrorsAndMessages(errors: string[]) {
    if (errors.some(err => this.validationMessages.includes(err))) {
      this.errors = [];
      this.messages = errors.filter(err => this.validationMessages.includes(err));
    } else {
      this.messages = [];
      this.errors = errors;
    }
  }
}
